import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,

	state: {
		lstLx7: [],
		loading: false,
	},

	mutations: {
		setLstLx7(state, lstLx7) {
			state.lstLx7 = lstLx7
		},
		setLoading(state, loading) {
			state.loading = loading
		},
	},

	actions: {
		async findByProfile({ commit, dispatch }, lx6perfil) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Price/CostProfileComponent/FindByProfile/${lx6perfil}`)
				.then(response => {
					let lx7 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstLx7", lx7 || [])
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},

		async insertComponent({ dispatch }, component) {
			return await this._vm.$axios
				.post("/Price/CostProfileComponent/Insert", component)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
		},

		async deleteByProfileComponent({ dispatch }, { lx7perfil, lx7item }) {
			return await this._vm.$axios
				.delete(`/Price/CostProfileComponent/DeleteByProfileComponent/${lx7perfil}/${lx7item}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
		},
	},
}
